import { Button, NotificationContainer } from '@repo/go-ui';
import { clsx } from 'clsx';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { useService } from 'src/packages/di';

import { ALERT_NOTIFICATIONS_CONTAINER_ID } from './AlertNotifications.consts';
import styles from './AlertNotificationsContainer.module.scss';

export const AlertNotificationsContainer = observer(function AlertNotificationsContainer() {
  const { t } = useTranslation();
  const anomalyNotificationsService = useService('anomalyNotificationsService');
  const hasNotifications = anomalyNotificationsService.notificationsCount > 0;

  return (
    <>
      <Button
        className={clsx(styles.hideAllButton, hasNotifications && styles.hideAllButton_visible)}
        disabled={!hasNotifications}
        variant="secondary"
        onClick={anomalyNotificationsService.hideAllNotifications}
      >
        {t('anomalyNotifications:actions.hideAll')}
      </Button>
      <NotificationContainer
        bodyClassName={styles.bodyClassName}
        className={styles.container}
        containerId={ALERT_NOTIFICATIONS_CONTAINER_ID}
        fitContentWidth
        newestOnTop
        overflowStrategy="keep-newest-visible"
        position="top-right"
        enableMultiContainer
      />
    </>
  );
});
